
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="relative">
            <div className="text-8xl font-thin text-[#00D9FF] opacity-20 absolute -top-8 -left-4">01</div>
            <div className="relative z-10">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#0A1628] mb-8 leading-tight">
                Protecting Your<br />
                Privacy Since<br />
                <span className="text-[#00D9FF]">Day One</span>
              </h2>
              
              <div className="space-y-6 text-[#6B7B93] leading-relaxed">
                <p>
                  ELTROM S.R.L. was founded with a simple yet powerful mission: to provide 
                  uncompromising digital security and privacy protection for individuals and 
                  businesses around the world. Our commitment to excellence drives every aspect 
                  of our VPN technology development.
                </p>
                
                <p>
                  Based in Mendoza, Argentina, we understand the importance of digital freedom 
                  and the need for secure, private internet access. Our team of cybersecurity 
                  experts works tirelessly to ensure that your online activities remain 
                  completely private and protected from any form of surveillance or data theft.
                </p>
                
                <p>
                  With our advanced VPN solution, we combine cutting-edge encryption technology 
                  with a robust global infrastructure to deliver fast, reliable, and secure 
                  internet connections. Trust ELTROM to be your shield in the digital world.
                </p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/016f6c1fb9c61dfbb4e710901c61e317.jpg"
                alt="ELTROM Team"
                className="w-full h-80 object-cover"
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/40 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-8 -right-8 bg-white p-6 rounded-2xl shadow-xl border border-gray-100">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-[#00D9FF] rounded-xl flex items-center justify-center">
                  <i className="ri-award-line text-xl text-white"></i>
                </div>
                <div>
                  <div className="text-lg font-bold text-[#0A1628]">Industry Leader</div>
                  <div className="text-sm text-[#6B7B93]">Cybersecurity Excellence</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Company Values */}
        <div className="mt-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-[#0A1628] mb-4">Our Core Values</h3>
            <p className="text-[#6B7B93] max-w-2xl mx-auto">
              The principles that guide everything we do at ELTROM S.R.L.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-shield-check-line',
                title: 'Security First',
                desc: 'We prioritize your digital security above all else, implementing the highest standards of encryption and protection.'
              },
              {
                icon: 'ri-eye-off-line',
                title: 'Privacy Commitment',
                desc: 'Your privacy is sacred to us. We maintain a strict no-log policy and never compromise on user confidentiality.'
              },
              {
                icon: 'ri-rocket-line',
                title: 'Innovation Drive',
                desc: 'We continuously evolve our technology to stay ahead of emerging threats and provide cutting-edge solutions.'
              }
            ].map((value, index) => (
              <div key={index} className="bg-[#F7F9FC] rounded-2xl p-8 text-center hover:bg-white hover:shadow-lg transition-all duration-300 group">
                <div className="w-16 h-16 bg-[#00D9FF] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${value.icon} text-2xl text-white`}></i>
                </div>
                <h4 className="text-xl font-bold text-[#0A1628] mb-4">{value.title}</h4>
                <p className="text-[#6B7B93] leading-relaxed">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
